import { RootState } from '@/store/main';

export const getSpeakers = (state: RootState) => state.speakers.speakers;
export const getIsLoadingSpeakers = (state: RootState) => state.speakers.loadingSpeakers;
